import { Box, ListItemIcon, MenuItem, Typography } from "@mui/material";
import React from "react";
import { DealDocumentRowItemActionsMenu } from "./DealDocumentRowItemActionsMenu";
import DocumentDownloadIcon from "../../../common/icons/document/documentDownloadIcon";
import { downloadScheduleOfPurchasers } from "../../../../api/deals/documents";
import { toValidIdentifier } from "../../../../helpers/utilsTS";
import { DealDocumentRow } from "./DealDocumentRow";
import { DealDocumentRowActionContainer } from "./DealDocumentRowItem";

export type ScheduleOfPurchasersRowItemProps = {
  orgId: number;
  dealId: number;
  showActions?: boolean;
};
export const ScheduleOfPurchasersRowItem = (
  props: ScheduleOfPurchasersRowItemProps
) => {
  const { orgId, dealId, showActions = true } = props;

  return (
    <DealDocumentRow
      orgId={orgId}
      dealId={dealId}
      dealDocumentId={undefined}
      documentName={"Schedule Of Purchasers"}
      editMode={false}
      setEditMode={() => {
        alert("if you see this, something is broken");
      }}
    >
      {showActions && (
        <DealDocumentRowActionContainer>
          <Box className="secondary-action">
            <DealDocumentRowItemActionsMenu
              dataTestId={`open-${toValidIdentifier(
                "Schedule Of Purchasers"
              )}-row-action-menu`}
            >
              <MenuItem
                onClick={() => {
                  downloadScheduleOfPurchasers(orgId, dealId);
                }}
              >
                <ListItemIcon>
                  <DocumentDownloadIcon
                    dataTestId={"download-schedule-of-purchasers-button"}
                    className={"row-action-icon"}
                  />
                </ListItemIcon>
                <Typography variant="inherit">Download</Typography>
              </MenuItem>
            </DealDocumentRowItemActionsMenu>
          </Box>
        </DealDocumentRowActionContainer>
      )}
    </DealDocumentRow>
  );
};
